import { BeneficiaryDetail } from "./beneficiaries.interface";
import { ConfigResponse } from "./config.interface";
import { MemberEnrolmentResponse } from "./enrollment.interface";

export class DecidingFunctionDTO {
     corporateConfig: ConfigResponse;
     enrollmentDetails: MemberEnrolmentResponse;
     activeBenefs: BeneficiaryDetail[];
}